import React from 'react';
import styled from 'styled-components';
import SGBody from 'components/Typography/SGBody';
import SGChip from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';
import formatLabel from 'utils/formatLabel';

const StyledChipContainer = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  &.hide {
    display: none;
  }
`;

const StyledChip = styled(SGChip)`
  background-color: ${props => props.theme.disabledStateBlue};
  color: ${props => props.theme.activeStateBlue};
  text-transform: capitalize;
  font-family: 'Text Regular';
  font-size: 0.875rem;

  &:focus.MuiChip-deletable {
    background-color: ${props => props.theme.disabledStateBlue};
  }
  &.uppercase {
    text-transform: uppercase;
  }
  .MuiSvgIcon-root {
    color: ${props => props.theme.activeStateBlue};
    margin-right: 8px;
  }
  .MuiChip-deleteIcon {
    height: 1.125rem;
    width: 1.125rem;
  }

  &:hover .MuiSvgIcon-root {
    opacity: 0.5;
  }
`;

interface ChipProps {
  category: string;
  label: string;
  selectedFilters: string[];
  handleFilterChange: (value: string[], category: string) => void;
  className?: string;
}

function Chip({category, selectedFilters, label, className, handleFilterChange}: ChipProps) {
  const isAnyChipSelected = selectedFilters.length > 0;

  return (
    <StyledChipContainer className={className + ' ' + (!isAnyChipSelected && 'hide')}>
      <SGBody variant="b4" noWrap>
        {label}:
      </SGBody>
      {selectedFilters.map(filter => (
        <StyledChip
          key={filter}
          label={formatLabel(filter)}
          id={filter}
          onDelete={() => {
            handleFilterChange([filter], category);
          }}
          deleteIcon={<CloseIcon />}
        />
      ))}
    </StyledChipContainer>
  );
}

export default Chip;
